/*  dead but tested file: Recognized as dead file, but used by go/src/atlas/encrypted_folder_download/service_worker/src/service_worker.ts */

import {createSymmetricCoreCrypto} from 'metaserver/static/js/encrypted_folder/crypto/core_crypto';
import type {FileKey} from 'metaserver/static/js/encrypted_folder/ekms/types';
import type {PerRevisionKeyInfo} from 'metaserver/static/js/encrypted_folder/content/types';
import type {
  Algorithm,
  SymmetricCryptoExtras,
} from 'metaserver/static/js/encrypted_folder/crypto/types';
import {decryptPerRevisionKey} from 'metaserver/static/js/encrypted_folder/content/per_revision_key';

export const decryptChunk = async (
  chunk: Uint8Array<ArrayBuffer>,
  fileKey: FileKey,
  algorithm: Algorithm,
  perRevisionKeyInfo: PerRevisionKeyInfo,
  extras: SymmetricCryptoExtras
) => {
  const perRevisionKey = await decryptPerRevisionKey(perRevisionKeyInfo, algorithm, fileKey);

  const symmetricCrypto = createSymmetricCoreCrypto(algorithm);
  return symmetricCrypto.decrypt(chunk, perRevisionKey, extras);
};
